
import * as React from 'react';
import { ListItem, StyledComponentProps, Divider, Grid, Typography } from '@material-ui/core';
import { contactInsurance } from '../../../../model/contactsubscription';
import moment from 'moment';
import { isExpired, isNearExpiration } from './SubscriptionItem';

interface IProps extends StyledComponentProps {
    // doneReminder: (reminder: reminder, done: boolean) => void;
    // onSubscriptionClick: (_id: string) => void;
    insurance: contactInsurance;
    onSelectItem: (item: any) => void;
    // isSelected: boolean;
    // showContactInfo?: boolean;
    // navigateTo: (path: string) => void;
}

// export class SubscriptionItem extends React.Component<IProps, IState> {
export const InsuranceItem = (props: IProps) => {

    const { insurance, classes, onSelectItem } = props;
    return (
        <>
            <ListItem key={insurance._id}
                onClick={() => onSelectItem(insurance)}
                className={isExpired(insurance.expiresOn) ? classes.isExpired : (isNearExpiration(insurance.expiresOn) ? classes.isNearExpiration : classes.isValid)}>
                <Grid container>
                    <Grid item xs={8} style={{ whiteSpace: 'pre' }}>
                        <Typography className={classes.typoPurchased}>
                            {"Iscrizione Annuale"}
                            {insurance.notes && insurance.notes !== "" ? `\n` + insurance.notes : ""}
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography className={classes.typoPurchased}>
                            {'Valido dal: ' + moment(insurance.validFrom).format('L')}</Typography>
                        <Typography className={classes.typoPurchased}>
                            {'Scade il: ' + moment(insurance.expiresOn).format('L')}</Typography>
                    </Grid>
                </Grid>
            </ListItem>
            <Divider />
        </>
    );
}